const SubAbasDenominacoesGenericas = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/produtosdaf/denominacoes/${id}/dadosgerais`,
  },
  // {
  //   label: 'Vínculos',
  //   rota: `/daf/produtosdaf/denominacoes/ficha/${id}/vinculos`,
  // },
];

export default SubAbasDenominacoesGenericas;
